import {useState} from "react"
import {Toast} from "./polaris/toast"
import qr_q from "../assets/qr-q.jpg" 
import {Divider} from "./polaris/divider"
import {Button} from "./polaris/button"
function Pay() {
    const [toaststt, setToaststt] = useState(null);

    const handleCopy = () => {
        const textToCopy = "9017041383368"; // Số tài khoản
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                setToaststt(true); // Đánh dấu đã sao chép thành công
				setTimeout(function(){
					setToaststt(null)
				},1500)
            })
            .catch(err => {
                console.error("Không thể sao chép: ", err);
            });
    };

    return (
        <>
            <div className="min-h-screen flex">
                <div className="self-center mx-auto p-4">
                    <section className="grid grid-cols-1 gap-2 lg:grid-cols-2 p-0 max-w-[1000px] bg-[#f1f2f1] container mx-auto rounded-lg lg:px-0 my-6 w-full"
                        style={{
                            boxShadow: '9px 17px 16px 2px rgba(0, 0, 0, 0.75)',
                            WebkitBoxShadow: '9px 17px 16px 2px rgba(0, 0, 0, 0.75)',
                            MozBoxShadow: '9px 17px 16px 2px rgba(0, 0, 0, 0.75)',
                        }}>
                            <div className="p-6">
                                <img className="max-w-[250px] mx-auto" src="https://timo.vn/wp-content/uploads/feature-manage-money.png"/>
                                <p className="px-6">Vui lòng thanh toán cho tôi qua số tài khoản Ngân hàng Timo</p>
                                <Divider/>
                                <div className="w-[300px] mx-auto">
                                    <Button click={handleCopy}>
                                        9017041383368 ( ấn để copy )
                                    </Button>
                                </div>
                            </div>

                            <div className="bg-white rounded-b-lg lg:rounded-r-lg flex">
                                <img src={qr_q} className="mx-auto self-center"/>
                            </div>
                    </section>
                </div>
            </div>
			<Toast status={toaststt}>Đã copy</Toast>
        </>
    );
}
export default Pay;